import { FC } from 'react';
import { useParams } from 'react-router';

import { useRouter } from '@cvt/routing';

import { EditStoryPartial } from '../partials/EditStoryPartial';


export const EditStory: FC = () => {
  const { storyId } = useParams();
  const router = useRouter();

  if (!storyId) {
    router.stories.go();
    return null;
  }

  return (
    <EditStoryPartial storyId={parseInt(storyId, 10)}/>
  );
};
